export default "<ngx-loading [show]=\"isLoading\"\n             [config]=\"config\"\n></ngx-loading>\n";